import {
    Document,
    Page,
    View,
} from '@react-pdf/renderer';

import styles from './styles/styles';
import Header from './components/header';
import Overview from './components/overview';
import Measurements from './components/measurements';
import Metrics from './components/metrics';
import Footer from './components/footer';

interface Species {
    abr: string;
    lat: string;
}

interface WoodChipStackDeliveryNoteProps {
    printLogo: string | undefined;
    headerLabels: {
        title: string;
        date: string;
        buyer: string;
        seller: string;
        measuredBy: string;
        forest: string;
        certificate: string;
        claims: string;
        note: string;
    };
    headerData: {
        date: string;
        buyer: string;
        seller: string;
        measuredBy: string;
        forest: string;
        certificateNumber: string;
        claims: string;
        note: string;
    };

    overviewLabels: {
        header: string;
        stackNumber: string;
        assortment: string;
        species: string;
        effectiveLength?: string;
        avgDiameter?: string;
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
        map: string;
        gps: string;
        nearestAddress: string;
        origin: string;
        link: { label: string; href: string };
        measMethod?: string;
        longestLog?: string;
        shortestLog?: string;
        avgLength?: string;
        avgVol?: string;
    };
    overviewData: {
        stackNumber: string;
        assortment: string;
        species: Species[];
        effectiveLength?: string;
        avgDiameter?: string;
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
        gpsCoordinates: { lat: number; long: number };
        nearestAddress?: string;
        origin: string;
        measMethod?: string;
        longestLog?: string;
        shortestLog?: string;
        avgLength?: string;
        avgVol?: string;
    };

    measurementsLabels: {
        header: string;
        section: string;
        front: string;
        back?: string;
        correction: string;
        middleValues: string;
        height: string;
        length: string;
        solidPercentage: string;
        supportCount?: string;
        rejectCount?: string;
    };
    measurementsData: {
        measurements: {
            section: number | string;
            front: string;
            back?: string;
        }[];
        solidInputs?: Record<string, string>;
        solidInputLabels?: Record<string, string>;
        avgHeight: string;
        avgLength: string;
        solidPercentage: string;
        countSupports?: string;
        countRejects?: string;
    };

    metricsLabels: {
        volumeAndWeight: string;
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
        bark: string;
    };
    metricsData: {
        volumeRm?: string;
        volumeM3?: string;
        weightTon?: string;
    };

    stackDeliveryNoteFooter: string;
}

const WoodChipStackDeliveryNote = ({
    printLogo,
    headerLabels,
    headerData,

    overviewLabels,
    overviewData,

    measurementsLabels,
    measurementsData,

    metricsLabels,
    metricsData,

    stackDeliveryNoteFooter
}: WoodChipStackDeliveryNoteProps) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <Header
                        labels={headerLabels}
                        data={headerData}
                        logoSrc={printLogo}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Overview
                        labels={overviewLabels}
                        data={overviewData}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Measurements
                        labels={measurementsLabels}
                        data={measurementsData}
                    />

                    <View style={styles.spacer} /><View style={styles.line} /><View style={styles.spacer} />

                    <Metrics
                        labels={metricsLabels}
                        data={metricsData}
                    />
                </View>

                <Footer footerText={stackDeliveryNoteFooter} />
            </Page>
        </Document>
    );
}

export default WoodChipStackDeliveryNote;
